export const CONTINUE_WATCHING_STALE_TIME = 1000 * 60 * 5; // 5 minutes
export const CONTINUE_WATCHING_PAGE_SIZE = 500;
